// extracted by mini-css-extract-plugin
export default {"container":"PdfRenderer_container__YRVdC","pdfWrapper":"PdfRenderer_pdfWrapper__OxxmU","iframe":"PdfRenderer_iframe__bfsEb"};